export default {
  // START:: SET APP THEME
  setAppTheme(state, payload) {
    state.dr_mohamed_admin_dashboard_theme = payload;
  },
  // END:: SET APP THEME
};
